import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  FOT: {
    color: "#ff4b4f",
    marginLeft: 4,
    fontSize: 12
  },
  FOTButton: {
    zIndex: 1
  }
});
